import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { PeriodPreset } from "../../lib/PERIOD_PRESETS";

export const PERIOD_LABELS: Record<PeriodPreset, MessageDescriptor> = {
  today: msg`Today`,
  yesterday: msg`Yesterday`,
  last_7_days: msg`Last 7 days`,
  last_14_days: msg`Last 14 days`,
  last_30_days: msg`Last 30 days`,
  this_month: msg`This month`,
  last_month: msg`Last month`,
};
